<script setup>

import TelegramChat from "@/components/PersonalAccount/TelegramChat/TelegramChat.vue";
import {useSettingsStore} from "@/store/settings";
const settings = useSettingsStore()
</script>

<template>
  <div class="personalAccount">
    <div class="personalAccount__navigator">
      <div class="personalAccount__partHead">
        ПРОФИЛЬ
      </div>
      <div class="personalAccount__item">
        <dt>
          <router-link :to="{name: 'OrdersView'}">ЗАКАЗЫ</router-link>
        </dt>
        <dd class="personalAccount__orderCount">
          {{settings.orderCount}}
        </dd>
      </div>
      <div class="personalAccount__item">
        <hr/>
      </div>

    <div class="personalAccount__item">
      <dt>
        <router-link :to="{name: 'ContactsView'}">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="none"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M16.498 12.69v2.25a1.5 1.5 0 0 1-1.635 1.5 14.84 14.84 0 0 1-6.472-2.303 14.6 14.6 0 0 1-4.5-4.5 14.84 14.84 0 0 1-2.303-6.502A1.5 1.5 0 0 1 3.081 1.5h2.25a1.5 1.5 0 0 1 1.5 1.29 9.6 9.6 0 0 0 .525 2.108 1.5 1.5 0 0 1-.338 1.582l-.952.953a12 12 0 0 0 4.5 4.5l.952-.953a1.5 1.5 0 0 1 1.583-.338c.68.254 1.387.43 2.107.526a1.5 1.5 0 0 1 1.29 1.522"
            />
          </svg>
          КОНТАКТЫ
        </router-link>
      </dt>
    </div>
  </div>
    <section class="personalAccount__detail">
      <router-view>

      </router-view>
    </section>
    <section class="personalAccount__tools">
        <TelegramChat></TelegramChat>
    </section>
  </div>
</template>

<style scoped lang="scss">
.personalAccount {
  display: grid;
  grid-template-columns: 282px 1fr auto;
  column-gap: 24px;
  align-items: start;

  // Планшет: nav слева, detail справа, tools — под обеими колонками
  @include respond-to('lg') {
    grid-template-columns: 282px 1fr;
    grid-template-areas:
      "nav   detail"
      "tools tools";
  }

  // Мобиле: flex-column — просто стек
  @include respond-to('md') {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &__navigator {
    min-height: 400px;
    border-radius: 20px;
    gap: 16px;
    padding: 24px;
    background-color: var(--cd-card-bg);
    text-align: left;
    display: flex;
    flex-direction: column;

    @include respond-to('lg') { grid-area: nav; }
    @include respond-to('md') { min-height: auto; }
  }

  &__detail {
    min-width: 0;
    @include respond-to('lg') { grid-area: detail; }
  }

  &__tools {
    @include respond-to('lg') { grid-area: tools; }
  }
  &__item {
    display: flex;
    justify-content: space-between;
    line-height: 37px;
    a {
      color: var(--cd-text-muted);
      display: flex;
      gap: 10px;
      align-items: center;
    }
    hr {
      width: 100%;
      border: 1px solid var(--cd-spoiler-border-color);
    }
  }

  &__partHead {
    color: var(--cd-base-green);
    font-size: 16px;
    font-weight: 400;
    font-family: var(--cd-default-font);
    line-height: 37px;

  }
  &__orderCount {
    background: var(--cd-button-bg-color);
    border-radius: 1000px;
    font-size: 12px;
    min-width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    flex-shrink: 0;
  }
}
</style>
